

























































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Surface, Typography } from '@/components/atoms';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import PreviewReferral from '@/components/molecules/Referral/PreviewReferral/PreviewReferral.vue';
import Statistics from '@/components/organisms/Referral/Statistics.vue';

import ReferralExisting from '@/components/icons/ReferralExisting.vue';
import ReferralNew from '@/components/icons/ReferralNew.vue';

import {
  IBusinessReferral,
  IBusinessReferralChart
} from '@/models/marketingCenter/referral';

import { treatError } from '@/utils';
import DateUtils from '@/utils/DateUtils';
import isMobile from '@/utils/mobile-check';
import eventBus from '@/utils/eventBus';

import ReferralService from '@/api/ReferralService';

@Component({
  components: {
    Surface,
    Typography,
    Checkbox,
    ReferralExisting,
    ReferralNew,
    PreviewReferral,
    Statistics
  }
})
export default class ReferralItem extends Vue {
  referralService = new ReferralService();
  @Prop() campaign!: IBusinessReferral;
  @Prop() chart!: IBusinessReferralChart;

  async triggerActivation() {
    eventBus.$emit('changeReferralCampaignStatus', {
      status: !this.status,
      id: this.campaignId
    });
  }

  edit() {
    this.$analytics({
      eventCategory: 'Referral Program | Edit button',
      eventAction: 'click',
      eventLabel: 'Clicked on the "Edit Referral Program Settings" button'
    });

    this.$router.push('/referral-program/edit');
  }

  get status() {
    return this.campaign.isActive;
  }

  get campaignId() {
    return this.campaign.id;
  }

  get type() {
    if (!this.coins) return 'referred';
    if (!this.percentage) return 'referring';

    return 'both';
  }

  get isMobileDevice() {
    return isMobile();
  }

  get coins() {
    return Number(this.campaign.referringDiscount);
  }

  get percentage() {
    return Number(this.campaign.referredDiscount);
  }

  get tPrefix() {
    return 'referralProgram.campaign';
  }
}
